const treeStore = {
  state: {
    tree: [],
    lastSelectedNode: '',
    props: {
      label: 'label',
      children: 'children',
      isLeaf: 'leaf'
    },
    default_expanded_keys: [],
    default_checked_keys: []
  },
  namespaced: true,
  mutations: {
    SET_DATA: function (state, json) {
      state.tree = json
    },
    EMPTY_DATA: function (state, json) {
      state.data = json
    },
    SET_PROPS: function (state, config) {
      state.props = config
    },
    SET_PROPS_BY_KEY: function (state, [key, value]) {
      state.props[key] = value
    },
    SET_LAST_SELECTED_NODE: function (state, node) {
      state.lastSelectedNode = node
    },
    SET_COMPANYID: function(state, data) {
      state.companyId = data

    }
  },
  actions: {
    treeData: function ({commit}, json) {
      commit('SET_DATA', json)
    },
    treeProp: function ({commit}, json) {
      if (json) {
        if (typeof json === 'string' && json.indexOf(':') > -1) {
          let a = json.split(':');
          commit('SET_PROPS_BY_KEY', [a[0], a[1]])
        }
        else if (typeof json === 'object' && json.label && json.children) {
          commit('SET_PROPS', json)
        }
        else if (typeof json === 'object' && json.label && !json.children) {
          commit('SET_PROPS_BY_KEY', ['label', json.label])
        }
        else if (typeof json === 'object' && !json.label && json.children) {
          commit('SET_PROPS_BY_KEY', ['label', json.children])
        }

      }
    },
    getTreeDataFromServer: function({ commit }, config) {
      return new Promise(function(resolve, reject) {
        var api = config['api'];
        var param = config['param'];
        var filter = config['filter'];
        if(api&& typeof api == "function"){
          api(param).then(response => {
            commit('SET_DATA',response.data);
            resolve(response)
          }).catch(error => {
            reject(error)
          })
        }else{
          console.log("API 设置不正确")
        }
      })
    },
    setLastNode:function({commit},config){
      commit('SET_LAST_SELECTED_NODE',config)
    }
  }
};
export default treeStore
